import { privateApi } from '../config/api';

class FiatPurchaseService {
  constructor() {
    this.baseURL = '/v1/fiat-purchase';
  }

  /**
   * Submit a fiat purchase request
   * @param {Object} requestData - The purchase request data
   * @returns {Promise<Object>} Response from the server
   */
  async submitPurchaseRequest(requestData) {
    try {
      const response = await privateApi.post(`${this.baseURL}/submit/`, requestData, {
        timeout: 30000 // 30 seconds timeout
      });
      return response.data;
    } catch (error) {
      console.error('Error submitting fiat purchase request:', error);
      throw error.response?.data || error.message;
    }
  }

  /**
   * Get available payment methods
   * @returns {Promise<Array>} List of available payment methods
   */
  async getPaymentMethods() {
    try {
      const response = await privateApi.get(`${this.baseURL}/payment-methods/`);
      return response.data.payment_methods;
    } catch (error) {
      console.error('Error getting payment methods:', error);
      throw error.response?.data || error.message;
    }
  }

  /**
   * Get fiat exchange rates
   * @returns {Promise<Object>} Digital Asset Marketplace rates for fiat currencies
   */
  async getFiatRates() {
    try {
      // Using ExchangeRate-API (free tier: 1,500 requests/month)
      const response = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
      const data = await response.json();
      
      if (data.rates) {
        return data.rates;
      }
      
      // Fallback to static rates
      return {
        USD: 1,
        GBP: 0.79,
        EUR: 0.92
      };
    } catch (error) {
      console.error('Error fetching fiat rates:', error);
      // Return static fallback rates
      return {
        USD: 1,
        GBP: 0.79,
        EUR: 0.92
      };
    }
  }
}

export default new FiatPurchaseService();
